<template>
  <p
    v-if="checkedLength || isFilterActive"
    class="selected-row-counter">
    {{ counterText }}
  </p>
</template>

<script>
export default {
  name: 'QxSelectedRowCounter',
  props: {
    collectionLength: {
      type: Number,
      required: true,
    },
    fullCollectionLength: {
      type: Number,
      required: true,
    },
    checkedLength: {
      type: Number,
      required: true,
    },
    isFilterActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    counterText() {
      if (this.isFilterActive && this.checkedLength) {
        return this.$gettextInterpolate(
          this.$gettext('%{ checkedLength } of %{ collectionLength } filtered items selected'),
          { checkedLength: this.checkedLength, collectionLength: this.collectionLength }
        );
      }
      if (this.isFilterActive && !this.checkedLength) {
        return this.$gettextInterpolate(
          this.$gettext('%{ filteredLength } of %{ collectionLength } filtered items showing'),
          { filteredLength: this.collectionLength, collectionLength: this.fullCollectionLength }
        );
      }
      return this.$gettextInterpolate(this.$gettext('%{ checkedLength } of %{ collectionLength } items selected'), {
        checkedLength: this.checkedLength,
        collectionLength: this.collectionLength,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.selected-row-counter {
  font-size: 15px;
  min-width: 150px;
  margin: 5px 16px 0 0;
}
</style>
